/*@jsxRuntime automatic @jsxImportSource react*/
/*<!-- vale Google.Exclamation = NO -->*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const title = "Asset Schema", description = "Hightouch's Campaign Intelligence", lastUpdatedDate = new Date(1720742400000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: "Asset Schema",
        description: "Hightouch's Campaign Intelligence",
        lastUpdatedDate: "Fri Jul 12 2024 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: null,
        type: null,
        icon: null,
        toc: [{
          "value": "Overview",
          "depth": 0,
          "id": "overview"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      a: "a",
      h2: "h2",
      img: "img",
      ul: "ul",
      li: "li"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["Campaign Intelligence is available as an add-on on ", _jsx(_components.a, {
            href: "https://hightouch.com/pricing",
            children: "Business tier plans"
          }), "."]
        })
      }), "\n", _jsx(_components.h2, {
        id: "overview",
        children: "Overview"
      }), "\n", _jsx(_components.p, {
        children: "Assets are the most granular elements of a campaign. For paid channels this might be ads and for lifecycle marketing this might be an email or even a variant."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "campaign-intel/assets.png",
          alt: "Analytics tables"
        })
      }), "\n", _jsx(_components.p, {
        children: "We support the following asset types:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "email"
        }), "\n", _jsx(_components.li, {
          children: "SMS"
        }), "\n", _jsx(_components.li, {
          children: "ads"
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "campaign-intel/asset_types.png",
          alt: "Analytics tables"
        })
      }), "\n"]
    });
  }
}
export default MDXContent;
